import type { SVGProps } from 'react';

export const StickerFlashFixedStroke = (
  props: SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    {...props}
  >
    <path
      d="M48.542 2.2373L45.0537 9.26074H46.3906L48.6367 4.73047L53.1396 6.9668L41.499 30.4277H54.04L21.375 68H19.4141L24.2939 56.4385L21.2607 55.1973L26.4268 42.5996L14 42.5898L25.1006 20.001L21.2041 18.0674L28.332 3.6875L32.835 5.91504L31.1758 9.26074H39.4512L44.0391 0L48.542 2.2373Z"
      fill="var(--xdlColorIllustrationBackground)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.6792 11.3467H44.3054L33.4707 32.5231H49.4716L24.5793 61.1502L33.2812 40.5141H17.3467L31.6792 11.3467Z"
      fill="#FFDA5F"
      stroke="#1D2124"
      strokeWidth="0.8"
    />
    <path
      d="M37.4521 18.9303L45.3673 2.98633"
      stroke="#1D2124"
      strokeWidth="0.8"
    />
    <path
      d="M38.8271 30.153L49.9557 7.71582"
      stroke="#1D2124"
      strokeWidth="0.8"
    />
    <path
      d="M24.3799 17.3186L29.6598 6.66406"
      stroke="#1D2124"
      strokeWidth="0.8"
    />
    <path
      d="M24.3799 54.2214L29.2048 42.4482"
      stroke="#1D2124"
      strokeWidth="0.8"
    />
  </svg>
);
